import { showError, defineNuxtPlugin, useUniversalPost } from "#imports";
export default defineNuxtPlugin((nuxt) => {
  nuxt.hook("page:finish", async () => {
    try {
      await useUniversalPost("/cookie-verify", { baseURL: "/" });
    } catch (e) {
      const error = e;
      if (error.status === 403) {
        showError({ message: "(cookie-verifier) Cookie are not working properly", data: { type: "cookie-verify" } });
      }
    }
  });
});
